// extracted by mini-css-extract-plugin
export default {"resultInputElem":"resultInput_resultInputElem__43YzT","subjInpPair":"resultInput_subjInpPair__a8DcX","resultNameHeadElem":"resultInput_resultNameHeadElem__QbGiB"};